<template>
  <modal-default
    ref="pauseNotificationModal"
    title=""
    hide-close-button
  >
    <pause-confirmation/>

    <template v-slot:footer>
      <button-default @click="logout">Logout</button-default>
    </template>
  </modal-default>
</template>

<script>
import ModalBase from "../../../components/modal/ModalBase.vue";
import PauseConfirmation from "../../account/close-account-modal/PauseConfirmation.vue";
import api from "../../../api";
import router from "../../../router";

export default {
  name: "PauseNotificationModal",
  components: {PauseConfirmation, ModalBase},
  mounted() {
    this.$refs.pauseNotificationModal.open();
  },
  methods: {
    logout() {
      api.auth.logout().then(() => {
        router.push({ name: 'login' });
      })
    },
  }
}
</script>
